export default __webpack_public_path__ + "static/lp-fgts-whatsapp-phone-7b7403ab8e6fd0419a44f8849fc6b8ca.png";